import type { TextosDeVerificacion, TipoDeBiometria } from './biometria';

/** El `translate` del diccionario. */
type Traducir = (clave: string) => string;

/**
 * Los textos de Face ID en un solo sitio: si cambia una clave o el marcador `{tipo}`, se cambia
 * aquí. Sin importar el plugin (solo tipos), para que cualquier pantalla pueda usarlos.
 */

/** Para entrar con lo guardado (login) y para guardarlo (al activar). */
export const textosParaEntrar = (traducir: Traducir): TextosDeVerificacion => ({
	motivo: traducir('movil.biometria.entrar.motivo'),
	titulo: traducir('movil.biometria.entrar.titulo'),
	cancelar: traducir('movil.biometria.cancelar')
});

/** Para desbloquear una sesión que ya está abierta (`BloqueoBiometrico`). */
export const textosParaDesbloquear = (traducir: Traducir): TextosDeVerificacion => ({
	motivo: traducir('movil.biometria.motivo'),
	titulo: traducir('movil.biometria.dialogo'),
	cancelar: traducir('movil.biometria.cancelar')
});

/** Un texto con `{tipo}` sustituido por el nombre de lo que tiene el móvil («Face ID», «tu huella»…). */
export const conTipo = (traducir: Traducir, clave: string, tipo: TipoDeBiometria): string =>
	traducir(clave).replace('{tipo}', traducir(`movil.biometria.nombre.${tipo}`));
